import UserForm from "./UserForm";
import {useDispatch} from "react-redux";
import {useState} from "react";
import {createUser} from "../../../redux/slices/users";
import {toast} from "react-toastify";

export default function CreateUser({open, onClose}) {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)

    const handleSubmit = (data) => {
        console.log(data)
        setLoading(true)

        let email= data.email;
        let password = data.password;
        let additionalInfo = {'displayName': data.displayName,'email':data.email,'disabled':data.disabled,'photoURL':data.photoURL};
        let role= {...data.rights};
        dispatch(createUser({ email, password, additionalInfo, role }))
            .then((uid) => {
                console.log('Utilisateur créé avec succès ! UID:', uid);
                setLoading(false)
                toast.success('Utilisateur créé avec succès !')
                onClose && onClose()
            })
            .catch((error) => {
                console.error('Erreur lors de la création de l\'utilisateur :', error);
            });
    }


    return (
        <UserForm
            open={open}
            onClose={onClose}
            onSubmit={handleSubmit}
            loading={loading}
            title={"Creation utilisateur"}
        />
    )
}